import React, { useState } from 'react'
import { Icon, Label } from 'semantic-ui-react'
import { createInitials } from '../../../../global/common/dataAdjust'
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons'
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper'

/**
 * 
 * @param {*} props 
 * @returns a keypad
 */
const Keypad = (props) => {

  const { setScoresOn, maxValues, maxDigits, setNumber, match, handle_close } = props

  const { home, away } = match ?? {}
  const { name: name_home } = home ?? {}
  const { name: name_away } = away ?? {}

  const maxLength = (maxValues * maxDigits) + 1

  const [pickedPad, setPickedPad] = useState()
  const [selectedPad, setSelectedPad] = useState('away')
  const [padValue, setPadValue] = useState('')
  const [padValue1, setPadValue1] = useState('')
  const [padValue2, setPadValue2] = useState('')

  const handleUpdate_set = (opts, e) => {
    try {
      e && e.stopPropagation()
    } catch (error) {

    }
    props.handleUpdate(padValue)
  }

  const handleClearScores = (opts, e) => {
    e && e.stopPropagation()
    setPadValue('')
    setPadValue1('')
    setPadValue2('')
  }

  const handleButtonClick = (e, value) => {

    e && e.stopPropagation()

    if (pickedPad) {
      switch (pickedPad) {
        case 'away':
          let av = padValue1
          av += value
          if (av.length > maxDigits) { return false }
          setPadValue1(av)
          break;
        case 'home':
          let hv = padValue2
          hv += value
          if (hv.length > maxDigits) { return false }
          setPadValue2(hv)
          break;
        default:
          break;
      }
    } else {
      let pv = padValue
      pv += value
      if (pv.length > maxLength) { return false }
      if (pv.length === 2) { pv += '-' }
      const pvs = pv.split('-')

      setPadValue1(pvs[0])
      if (pvs.length === 2) { setPadValue2(pvs[1]) }

      setPadValue(pv)
      switch (pv.length) {
        case 0:
        case 1:
          setSelectedPad('away')
          break;
        default:
          setSelectedPad('home')
          break;
      }
    }
  }

  const handlePick = (value) => {
    setPickedPad(value)
    setSelectedPad(value)
  }

  const handleClose = (opts, e) => {
    setScoresOn && setScoresOn(e)
    handle_close && handle_close(e)
  }

  const handleClear = (e, value) => {

    if (pickedPad) {
      switch (pickedPad) {
        case 'away':
          setPadValue1('')
          break;
        case 'home':
          setPadValue2('')
          break;
        default:
          break;
      }
    } else {
      setPadValue('')
      setPadValue1('')
      setPadValue2('')
    }
  }

  const teamInitials = (name) => {
    let tt = createInitials(name)
    if (tt.length === 1) { tt = name.substring(0, 4) }
    return tt
  }

  const pad = (value, oc) => <div color={'blue'} onClick={(e) => { oc(e, value) }}>{value}</div>

  const scoreRow = (divs, start, end) => {
    for (var i = start; i <= end; i++) {
      divs.push(pad(i, handleButtonClick))
    }
  }

  const scoreGrid = () => {
    const divs = []
    scoreRow(divs, 1, 3)
    scoreRow(divs, 4, 6)
    scoreRow(divs, 7, 9)
    divs.push(pad('X', handleClear))
    divs.push(pad(0, handleButtonClick))
    divs.push(pad('<', handleClear))

    return <div className={'scorepad-container'}>
      {divs}
    </div>
  }

  const header = () => <div className={'scorepad-header'}>
    <div>{teamInitials(name_away)}</div>
    <div><Label color={selectedPad === 'away' ? 'green' : 'grey'} size={'big'} className={pickedPad === 'away' ? 'selected' : null} onClick={() => { handlePick('away') }}>{padValue1}</Label></div>
    <div><Label color={'blue'} >{'Set: '}{setNumber}</Label></div>
    <div><Label color={selectedPad === 'home' ? 'green' : 'grey'} size={'big'} className={pickedPad === 'home' ? 'selected' : null} onClick={() => { handlePick('home') }}>{padValue2}</Label></div>
    <div>{teamInitials(name_home)}</div>
  </div>

  const footer = () => {
    const btns = []
    if (handle_close || setScoresOn) { btns.push({ oc: handleClose, icon: 'delete', fl: true, color: 'red' }) }
    btns.push({ oc: handleClearScores, icon: 'ban', fl: true, color: 'grey' })
    btns.push({ oc: handleUpdate_set, caption: 'Update Set ' + setNumber, icon: 'check' })
    return <UiSaveButtons others={btns} />
  }

  const content = () => <Wrapper
    header={header()}
    content={scoreGrid()}
    footer={footer()}
    noMid={true}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ container: 'score-pad' }}
  />

  return content()

}

export default Keypad